import React from 'react';
import { Typography, CircularProgress, Grid } from '@material-ui/core';

interface Props {
  message?: string;
  size?: number;
  style?: any;
  color?: 'primary' | 'secondary';
};

const Loading: React.FC<Props> = ({ message, size = 40, style = {}, color = 'primary' }) => {
  return (
    <Grid
      container
      direction="column"
      style={{ height: '100%', ...style }}
      justify="center"
      alignItems="center"
      spacing={2}
    >
      {message && (
        <Grid item>
          <Typography align="center" variant="h5">{message}</Typography>
        </Grid>
      )}
      <Grid item>
        <CircularProgress color={color} size={size} />
      </Grid>
    </Grid>
  );
}

export default Loading;
